import { useEffect, useState } from "react";
import ReportsBasePage from "../BasePage";
import Reserved from "./Reserved";
import Commitment from "./Commitment";

export default function CommitedBalances(){
    const [carrying, setCarrying] = useState(false);
    const [balanceType, setBalanceType] = useState("Empenhados");
    const [qtdePage, setQtdePage] = useState(50);
    const [pageTypes, setPageTypes] = useState([
        {value: "Empenhados", label: "Empenhados"},
        {value: "Reservados", label: "Reservados"}
    ]);
    
    return (
        <ReportsBasePage 
            title={balanceType}
            carrying={carrying} 
            qtdePage={{state: qtdePage, setState: setQtdePage}} 
            choosePageTypes
            pageType={{state: balanceType, setState: setBalanceType}} 
            pageTypes={{state: pageTypes, setState: setPageTypes}}
        >
            {balanceType === "Reservados" &&
                <Reserved />
            }
            {balanceType === "Empenhados" &&
                <Commitment />
            }
        </ReportsBasePage>
    )
}